import axios from '@/utils/axiosHelper';

// 初始化数据(含授权)
export const onGetInitDataAPI = (params) => {
  return axios({ url: '/sword/map/init', method: 'GET', params }, { interceptResultCode: false });
};

// 开启格子
export const onGameStart = (params) => {
  return axios({ url: '/sword/map/lottery', method: 'POST', params }, { interceptResultCode: false });
};

// 分享获得次数
export const onGetShareCount = (params) => {
  return axios({ url: '/sword/map/share', method: 'POST', params }, { interceptResultCode: false });
};

// 帮助页初始化
export const onHelpInit = (params) => {
  return axios({ url: '/sword/map/help', method: 'GET', params }, { interceptResultCode: false });
};

// 点击帮助
export const onHelp = (params) => {
  return axios({ url: '/sword/map/help', method: 'POST', params }, { interceptResultCode: false });
};

// 点击帮助
export const getLink = (params) => {
  return axios({ url: '/sword/map/link', method: 'POST', params }, { interceptResultCode: false });
};


// WEBPACK FOOTER //
// ./src/pages/hjwq/online/api.js